import { T } from "@/i18n";
import { Skeleton } from "./ui/skeleton";

type PropertyMappingOverrides<T> = {
  [P in keyof T]?: (value: T[P] | null | undefined) => string;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function PropertyList<T extends Record<string, any>>({
  loading,
  labelPrefix,
  item,
  properties,
  propertyMappingOverrides,
}: {
  loading?: boolean;
  labelPrefix: string;
  item: T | null | undefined;
  properties: Array<keyof T>;
  propertyMappingOverrides?: PropertyMappingOverrides<T>;
}) {
  return (
    <>
      {properties.map((p) => {
        const propFromObject =
          propertyMappingOverrides?.[p]?.(item?.[p]) ?? item?.[p] ?? "-";
        const isboolean = typeof propFromObject === "boolean";
        return (
          <span className="text-muted-foreground text-sm" key={p as string}>
            <span className="text-foreground font-medium">
              <T tKey={`${labelPrefix}.${p.toString()}`} />:{" "}
            </span>
            {loading ? (
              <Skeleton className="h-3 w-1/4" />
            ) : isboolean ? (
              <T tKey={`common.boolean.${propFromObject}`} />
            ) : (
              propFromObject
            )}
          </span>
        );
      })}
    </>
  );
}
